import { render } from "./Focuspoints.vue?vue&type=template&id=5df4671a&scoped=true"
import script from "./Focuspoints.vue?vue&type=script&lang=js"
export * from "./Focuspoints.vue?vue&type=script&lang=js"

import "./Focuspoints.vue?vue&type=style&index=0&id=5df4671a&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df4671a"]])

export default __exports__